import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const shopifyConnectionStatusSchema = z.object({
  is_connected: z.boolean(),
  connection_type: z.enum(["oauth", "custom_app", "client_credentials"]).nullable(),
  store: z.string().nullable(),
  granted_scopes: z.array(z.string()),
  missing_scopes: z.array(z.string()),
});

export const shopifyApiDefinitions = prefixApi(
  "/shopify",
  apiBuilder({
    alias: "connectShop",
    method: "post",
    path: "/connect",
    parameters: [
      {
        name: "shop",
        type: "Query",
        schema: z.string(),
      },
    ],
    response: z.object({ org_id: z.number() }),
  })
    .addEndpoint({
      alias: "createShopifyClientCredentials",
      method: "post",
      path: "/client-credentials",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            store: z.string(),
            client_id: z.string(),
            client_secret: z.string(),
          }),
        },
      ],
      response: z.object({ store: z.string(), org_id: z.number() }),
    })
    .addEndpoint({
      alias: "getShopifyConnectionStatus",
      method: "get",
      path: "/auth/status",
      response: shopifyConnectionStatusSchema,
    })
    .addEndpoint({
      alias: "deleteShopifyConnection",
      method: "delete",
      path: "/client-credentials",
      status: 204,
      response: z.void(),
    })
    .build(),
);
